import React from 'react'

function Notifications() {
  return (
    <h5 style={{paddingLeft:"20%"}}>Notifications</h5>
  )
}

export default Notifications